/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  CreateTimesheetEntryMutationRequest,
  CreateTimesheetEntryMutationResponse,
} from '../models/CreateTimesheetEntry.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import {
  createTimesheetEntryMutationResponseSchema,
  createTimesheetEntryMutationRequestSchema,
} from '../zod/createTimesheetEntrySchema.ts';
import { useMutation } from '@tanstack/react-query';

export const createTimesheetEntryMutationKey = () =>
  [{ url: '/api/entries' }] as const;

export type CreateTimesheetEntryMutationKey = ReturnType<
  typeof createTimesheetEntryMutationKey
>;

/**
 * {@link /api/entries}
 */
export async function createTimesheetEntry(
  data: CreateTimesheetEntryMutationRequest,
  config: Partial<RequestConfig<CreateTimesheetEntryMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = createTimesheetEntryMutationRequestSchema.parse(data);
  const res = await request<
    CreateTimesheetEntryMutationResponse,
    ResponseErrorConfig<Error>,
    CreateTimesheetEntryMutationRequest
  >({
    method: 'POST',
    url: `/api/entries`,
    data: requestData,
    ...requestConfig,
  });
  return createTimesheetEntryMutationResponseSchema.parse(res.data);
}

/**
 * {@link /api/entries}
 */
export function useCreateTimesheetEntry<TContext>(
  options: {
    mutation?: UseMutationOptions<
      CreateTimesheetEntryMutationResponse,
      ResponseErrorConfig<Error>,
      { data: CreateTimesheetEntryMutationRequest },
      TContext
    > & {
      client?: QueryClient;
    };
    client?: Partial<RequestConfig<CreateTimesheetEntryMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? createTimesheetEntryMutationKey();

  return useMutation<
    CreateTimesheetEntryMutationResponse,
    ResponseErrorConfig<Error>,
    { data: CreateTimesheetEntryMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return createTimesheetEntry(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
